<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <el-card v-show="!editStatus" class="custom-card mb-20" shadow="never">
        <el-button v-if="calcPermission(permition, 1)" round type="danger" icon="el-icon-circle-plus-outline" @click="handleCreate">{{ $t('table.add') }}</el-button>
      </el-card>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!editStatus" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column
            type="index"
            width="100"
            align="center" />
          <el-table-column :label="$t('table.route')" min-width="100%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.PgUrl">{{ scope.row.PgUrl }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.name')" width="200px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.PgMemo">{{ scope.row.PgMemo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.sort')" width="120px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.PgSort>=0">{{ scope.row.PgSort }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.moduleName')" width="200px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.PgMenuNo">{{ scope.row.PgMenuNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.status')" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.PgStatusNo">{{ scope.row.PgStatusNo | PgStatusNoFilter }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center" width="230" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-link v-if="calcPermission(permition, 2)" class="custom-link" type="primary" size="mini" @click="handleUpdate(scope.row)">{{ $t('table.edit') }}</el-link>
              <el-link v-if="calcPermission(permition, 3)" class="custom-link" size="mini" type="danger" @click="handleDelete(scope.row)">{{ $t('table.delete') }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" layout="total, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </el-card>
      </div>
    </transition>
    <!-- 编辑/新增 -->
    <transition name="el-zoom-in-bottom">
      <div v-show="editStatus" class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col class="CommitForm">
              <el-form v-if="commitFrom" ref="commitFrom" :rules="rules" :model="commitFrom" label-position="right" label-width="100px">
                <el-form-item :label="$t(`table.name`)" prop="PgMemo">
                  <el-input v-model="commitFrom.PgMemo" class="filter-item" placeholder="请输入名称" />
                </el-form-item>
                <el-form-item :label="$t('table.route')" prop="PgUrl">
                  <el-input v-model="commitFrom.PgUrl" class="filter-item" placeholder="请输入应用地址" />
                </el-form-item>
                <el-form-item :label="$t(`table.module`)" prop="PgMenuNo">
                  <el-select v-model="commitFrom.PgMenuNo" class="filter-item" placeholder="请选择模块">
                    <el-option v-for="item in moduleList" :key="item.Base" :label="item.SName" :value="item.SStatusNo"/>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t(`table.btnPermission`)" :gutter="20" required>
                  <el-col v-for="(item, index) in commitFrom.PermitionMemo" :key="index" :span="20">
                    <el-input v-model="commitFrom.PermitionMemo[index]" class="filter-item" placeholder="请输入按钮名称" style="margin-bottom:10px;" />
                  </el-col>
                  <el-button :span="4" type="primary" icon="el-icon-plus" style="margin-left: 15px;" circle @click="addBtnPermition" />
                </el-form-item>
                <el-form-item :label="$t(`table.sort`)">
                  <el-input v-model="commitFrom.PgSort" class="filter-item" placeholder="请输入排序" />
                </el-form-item>
                <el-form-item :label="$t(`table.status`)" prop="PgStatusNo">
                  <el-select v-model="commitFrom.PgStatusNo" class="filter-item" placeholder="请选择状态">
                    <el-option v-for="item in calendarTypeOptions" :key="item.key" :label="item.display_name" :value="item.key"/>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-left: 60px" round class="filter-item" type="info" @click="cancelCommit">{{ $t('table.cancel') }}</el-button>
          <el-button v-if="calcPermission(permition, 4)" round class="filter-item" type="primary" @click="commitEdit('commitFrom')">{{ $t('table.submit') }}</el-button>

        </el-card>

      </div>
    </transition>
  </div>
</template>
<script>
import { qryStatusInfo, qryProgramInfo, addProgramInfo, modProgramInfo, delProgramInfo, qryRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令

const calendarTypeOptions = [
  { key: 'A', display_name: '启用' },
  { key: 'S', display_name: '禁用' }
]
const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})
export default {
  name: 'ApplicationManage',
  directives: {
    waves
  },
  filters: {
    PgStatusNoFilter(type) {
      return calendarTypeKeyValue[type]
    }
  },
  data() {
    return {
      editStatus: false,
      list: null,
      total: null,
      listLoading: true,
      tableKey: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      moduleListQuery: {
        pageIndex: 1,
        pageSize: 1000,
        modelName: 'MenuInfo'
      },
      calendarTypeOptions,
      moduleList: null,
      commitFrom: {
        PgId: 0,
        PgIcon: '',
        PgUrl: '',
        PgMenuNo: '',
        PgSort: 0,
        PgStatusNo: 'A',
        PgMemo: '',
        Permition: 2147483647,
        PermitionMemo: [],
        // PermitionMemo: ["查询","添加","提交","删除","修改"],
        PgStatusNo_: '启用'
      },
      PgStatusNo: '',
      SStatusNo: '',
      rules: {
        PgUrl: [
          { required: true, message: '请输入路由地址', trigger: 'change' }
        ],
        PgStatusNo: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        PgMenuNo: [
          { required: true, message: '请选择模块', trigger: 'change' }
        ],
        PgMemo: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      permition: 0
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList.forEach(item => {
        item.RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getList()
          }
        })
      })
      // this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
      //   if (this.$route.path === item.ProgramInfo.PgUrl) {
      //     this.permition = item.Permition
      //     this.getList()
      //   }
      // })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        // this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getList()
          }
        })
      })
    }
  },
  methods: {
    getList() {
      this.listLoading = true
      qryStatusInfo(this.moduleListQuery).then(response => {
        this.moduleList = response.LsList
      })
      qryProgramInfo(this.listQuery).then(response => {
        // response.LsList.forEach(item => {
        //   if (this.$route.path === item.PgUrl) {
        //     this.permition = item.Permition
        //   }
        // })
        this.list = response.LsList
        this.total = response.TotalRows
        this.commitFrom = {
          'PgId': 0,
          'PgIcon': '',
          'PgUrl': '',
          'PgMenuNo': '',
          'PgSort': 0,
          'PgStatusNo': 'A',
          'PgMemo': '',
          'Permition': 2147483647,
          'PermitionMemo': [],
          'PgStatusNo_': '启用'
        }
        this.listLoading = false
      })
    },
    handleCreate() {
      this.editStatus = true
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    handleUpdate(row) {
      this.commitFrom = row
      if (typeof this.commitFrom.PermitionMemo === 'string') {
        this.commitFrom.PermitionMemo = JSON.parse(this.commitFrom.PermitionMemo.replace(/'/g, '"'))
      }
      if (this.commitFrom.PgStatusNo === 'A') {
        this.commitFrom.PgStatusNo_ = '启用'
      } else {
        this.commitFrom.PgStatusNo_ = '禁用'
      }
      this.editStatus = true
    },
    commitEdit(formName) {
      if (this.commitFrom.PermitionMemo.length === 0) {
        this.$message.warning('请检查数据格式是否正确1')
        return false
      } else {
        if (this.commitFrom.PermitionMemo.join('') === '') {
          this.$message.warning('请检查数据格式是否正确2')
          return false
        } else {
          this.commitFrom.PermitionMemo.forEach((item, index) => {
            if (!item || item === '') {
              this.commitFrom.PermitionMemo.splice(index, 1)
            }
          })
          if (typeof this.commitFrom.PermitionMemo !== 'string') {
            this.commitFrom.PermitionMemo = JSON.stringify(this.commitFrom.PermitionMemo)
          }
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.commitFrom.PgId > 0) {
            modProgramInfo(this.commitFrom).then(response => {
              this.getList()
              this.editStatus = false
            })
          } else {
            addProgramInfo(this.commitFrom).then(response => {
              this.getList()
              this.editStatus = false
            })
          }
        } else {
          this.$message.warning('请检查数据格式是否正确3')
          return false
        }
      })
    },
    addBtnPermition() {
      if (this.commitFrom.PermitionMemo.length === 0 || this.commitFrom.PermitionMemo[this.commitFrom.PermitionMemo.length - 1]) {
        this.commitFrom.PermitionMemo.push('')
      }
    },
    // removeDomain(index) {
    //   this.commitFrom.PermitionMemo.splice(index, 1)
    // },
    handleDelete(row) {
      this.$alert('该操作不可逆', '您确定要删除么', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            delProgramInfo(row).then(response => {
              this.getList()
            })
          }
        }
      })
    },
    cancelCommit() {
      this.commitFrom = {
        'PgId': 0,
        'PgIcon': '',
        'PgUrl': '',
        'PgMenuNo': '',
        'PgSort': 0,
        'PgStatusNo': 'A',
        'PgMemo': '',
        'Permition': 2147483647,
        'PermitionMemo': [],
        'PgStatusNo_': '启用'
      }
      this.editStatus = false
    }
  }
}
</script>
